<template>
  <div class="link-manage">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('nav.remotePay')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('linkManage.title')}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="remote-link" @click="genarateLink">{{$t('linkManage.btn.createLink')}}</el-button>
    </div>

    <div class="panel down">
      <div class="panel-header panel-header__auto">
        <el-form ref="form" :model="form" :rules="formRuls">
          <div class="panel-select-group">
            <div class="panel-select__wrapper resize">
              <span class="panel-select__desc">{{$t('linkManage.filterSe.createTime')}}</span>
              <el-form-item prop="dateRangeValue">
                <el-date-picker
                  v-model="form.dateRangeValue"
                  type="datetimerange"
                  :editable="false"
                  :placeholder="$t('tradeMng.panel.range')"
                  size="small"
                  :clearable="false">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="panel-select__wrapper">
              <el-form-item prop="choosetime">
                <el-radio-group v-model="form.choosetime" @change="changeTime">
                  <el-radio-button v-for="item in choosetimes" :label="item.value" :key="item.value">{{ item.name }}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="panel-select-group">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">{{$t('linkManage.filterSe.goodsName')}}</span>
              <el-form-item prop="goods_name">
                <el-input v-model="form.goods_name" class="fe_input"></el-input>
              </el-form-item>
              <span class="panel-select__desc">{{$t('linkManage.filterSe.creatorID')}}</span>
              <el-form-item prop="creator_id">
                <el-input v-model="form.creator_id"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="panel-select-group">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">{{$t('linkManage.filterSe.status')}}</span>
              <el-form-item prop="link_status">
               <el-select v-model="form.link_status" :placeholder="$t('common.all')" size="small">
                  <el-option v-for="item in statusList" :label="item.name" :value="item.value" :key="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="panel-header-btn-group">
              <div class="panel-header-btn panel-header-btn__fill" @click="search">
                <span class="el-icon-loading" v-if="loading"></span>
                <span v-else>{{$t('tradeMng.panel.btn.query')}}</span>
              </div>
              <div class="panel-header-btn transctl-btn" @click="reset">{{$t('tradeMng.panel.btn.reset')}}</div>
              <div class="panel-header-btn export_btn" @click="exportExcel">{{$t('common.export')}}</div>
            </div>
          </div>
        </el-form>
      </div>

      <div class="panel-body">
        <el-table
          :data="tableData"
          style="width: 100%"
          row-class-name="el-table__row_fix"
          v-loading="loading">
          <el-table-column :label="$t('orderManage.filter.linkId')" prop="link_id"></el-table-column>
          <el-table-column :label="$t('orderDetail.paymentlink')" prop="link_url"></el-table-column>
          <el-table-column :label="$t('linkManage.filterSe.goodsName')" prop="goods_name"></el-table-column>
          <el-table-column :label="$t('linkManage.filterSe.creatorID')" prop="creator_id"></el-table-column>
          <el-table-column :label="$t('linkManage.filterSe.customerName')" prop="customer_name"></el-table-column>
          <el-table-column :label="$t('linkManage.filterSe.customerPhone')" prop="customer_telephone"></el-table-column>
          <el-table-column :label="$t('linkManage.filterSe.status')" prop="status"></el-table-column>
          <el-table-column :label="$t('linkManage.filterSe.createTime')" prop="ctime"></el-table-column>
          <el-table-column :label="$t('shopmng.panel.table.op')" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="el-button__fix" @click="getAnotherLink(scope.row.link_id)">{{ $t('linkManage.detail.oneMore') }}</el-button>
              <el-button type="text" size="small" class="el-button__fix" @click="cancelLink(scope.row.link_id, 2)">{{ $t('linkManage.detail.cancel') }}</el-button>
              <el-button type="text" size="small" class="el-button__fix" @click="deleteLink(scope.row.link_id, 3)">{{ $t('linkManage.detail.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_wrapper" v-if="total >= 10">
        <el-pagination
          ref="page"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pagesize"
          @size-change="handleSizeChange"
          :total="total"
          @current-change="currentChange"
          :current-page="currentPage">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :visible.sync="show"
      size="tiny">
      <div slot="title" class="dialogTitle">
        <p>{{ $t('linkManage.detail.confirmCancel') }}</p>
      </div>
      <div class="dialogContent">
        <p>{{ $t('linkManage.detail.cancelMsg') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">{{ $t('linkManage.btn.cancel') }}</el-button>
        <el-button type="primary" :disabled="modifyBtn" @click="modifyLink">{{ $t('linkManage.filterSe.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showDelete"
      size="tiny">
      <div slot="title" class="dialogTitle">
        <p>{{ $t('linkManage.detail.confirmDelete') }}</p>
      </div>
      <div class="dialogContent">
        <p>{{ $t('linkManage.detail.deleteMsg') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDelete = false">{{ $t('linkManage.btn.cancel') }}</el-button>
        <el-button type="primary" :disabled="modifyBtn" @click="modifyLink">{{ $t('linkManage.filterSe.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import config from 'config'
import {formatDate} from '../../common/js/util';
import qs from 'qs'
export default {
  data () {
    return {
      form: {
        dateRangeValue: [],
        choosetime: '1',
        goods_name: '',
        creator_id: '',
        link_status: ''
      },
      total: '',
      page: 0,
      pagesize: 10,
      goods_info: '',
      shopName: '',
      currentPage: 1,
      show: false,
      showDelete: false,
      tableData: [],
      loading: false,
      status: false,
      operateLinkId: '',
      operateStatus: '',
      lang: config.lang,
      choosetimes: [
        {'name': this.$t('time.today'), 'value': '1'},
        {'name': this.$t('time.yesterday'), 'value': '2'},
        {'name': this.$t('time.near7'), 'value': '7'},
        {'name': this.$t('time.near30'), 'value': '30'}
      ],
      statusList: [
        {'name': this.$t('linkManage.filterSe.all'), 'value': ''},
        {'name': this.$t('linkManage.filterSe.pending'), 'value': '1'},
        {'name': this.$t('linkManage.filterSe.Success'), 'value': '2'},
        {'name': this.$t('linkManage.filterSe.fail'), 'value': '3'},
        {'name': this.$t('linkManage.filterSe.fullRefund'), 'value': '4'},
        {'name': this.$t('linkManage.filterSe.partialRefund'), 'value': '5'},
        {'name': this.$t('linkManage.filterSe.canceled'), 'value': '6'},
        {'name': this.$t('linkManage.filterSe.overdue'), 'value': '7'},
      ],
      formRuls: {},
      modifyBtn: false,
    }
  },
  watch: {
    'form.dateRangeValue': function(val) {
      if(!this.status) {
        this.form.choosetime = '';
      }
      this.status = false;
    },
  },
  created () {
    this.changeTime('1')
    this.getLinkList()
  },
  methods: {
    exportExcel () {
      let str = 'yyyy-MM-dd HH:mm:ss'
      let params = {
        goods_name: this.form.goods_name,
        link_status: this.form.link_status,
        creator_id: this.form.creator_id,
        stime: formatDate(this.form.dateRangeValue[0], str),
        etime: formatDate(this.form.dateRangeValue[1], str),
        format: 'cors',
        lang: this.lang,
        is_download: 1
      }
      window.location.href = `${config.oHost}/remotepay/link/pay_link_list?${qs.stringify(params)}`
    },
    changeTime(value) {
      if(value) {
        this.status = true;
        let end = new Date();
        let start = new Date(end.getTime() - 3600 * 1000 * 24 * (value - 1));

        if(value == 2) {
            end = new Date(end.getTime() - 3600 * 1000 * 24);
        }

        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);

        if(value != 1) {
          end.setHours(23);
          end.setMinutes(59);
          end.setSeconds(59);
        }
        this.form.dateRangeValue = [start, end];
      }
    },
    getLinkList () {
      let str = 'yyyy-MM-dd HH:mm:ss'
      if (!this.loading) {
        this.loading = true
        axios.get(`${config.oHost}/remotepay/link/pay_link_list`, {
          params: {
            goods_name: this.form.goods_name,
            link_status: this.form.link_status,
            creator_id: this.form.creator_id,
            is_download: this.form.is_download,
            stime: formatDate(this.form.dateRangeValue[0], str),
            etime: formatDate(this.form.dateRangeValue[1], str),
            page: this.page,
            pagesize: this.pagesize,
            format: 'cors'
          }
        }).then(res => {
          let data = res.data
          this.loading = false
          if (data.respcd === config.code.OK) {
            this.total = data.data.count
            this.tableData = data.data.links
          } else {
            this.$message.error(data.resperr)
          }
        })
      }
    },
    getAnotherLink (item) {
      this.$router.push({path: '/main/remotePay/remotePay', query: { link_id: item }})
      window.sessionStorage.removeItem('form')
      window.sessionStorage.removeItem('goods_info')
    },
    cancelLink (item, status) {
      this.show = true
      this.operateLinkId = item
      this.operateStatus = status
    },
    deleteLink (item, status) {
      this.showDelete = true
      this.operateLinkId = item
      this.operateStatus = status
    },
    currentChange(current) {
      if (!current && this.currentPage !== 1) {
        this.currentPage = 1
        this.page = 0
        return
      }
      if (current) {
        this.currentPage = current
        this.page = current - 1
      }
      this.getLinkList()
    },
    handleSizeChange(size = 10) {
      this.pagesize = size
      this.currentChange()
    },
    search () {
      this.handleSizeChange()
    },
    reset() {
      this.status = true
      this.$refs['form'].resetFields()
    },
    modifyLink () {
      let params = {
        link_id: this.operateLinkId,
        status: this.operateStatus,
        format: 'cors'
      }
      this.modifyBtn = true
      axios.post(`${config.oHost}/remotepay/link/pay_link_edite`, qs.stringify(params)).then(res => {
        let data = res.data
        if (data.respcd === config.code.OK) {
          this.show = false
          this.showDelete = false
          this.getLinkList()
          this.modifyBtn = false
        } else {
          this.modifyBtn = false
          this.$message.error(data.resperr)
        }
      })
    },
    genarateLink () {
      this.$router.push({path: '/main/remotePay/remotePay'})
      window.sessionStorage.removeItem('form')
      window.sessionStorage.removeItem('goods_info')
    }
  }
}
</script>

<style lang="scss">
  .panel-header__auto {
    height: auto !important;
    padding: 25px 0 20px 25px;
  }
  .el-date-editor--datetimerange {
    margin-right: 30px;
  }
  .el-date-editor--datetimerange.el-input {
    width: 296px;
  }
  .link-manage {
    .banner_wrapper {
      .el-breadcrumb__item__inner {
         color: #262424 !important;
      }
      .remote-link {
        position: relative;
        &::before {
          position: absolute;
          content: '+';
          color: #FFFFFF;
          font-size: 34px;
          left: 7px;
          top: 2px;
          font-weight: 300;
        }
        height: 40px;
        width: 162px;
        background-color: #7ed321;
        border-color: #7ed321;
        box-sizing: border-box;
        span {
          font-size: 17px;
          color: white;
        }
      }
    }
    .down {
      .panel-header {
        background-color: #fff;
      }
      .panel-select-group {
        margin-bottom: 20px;
        position: relative;
        .resize {
          margin-right: 0;
        }
        .export_btn {
          margin-left: 15px;
        }
        .orderno_nowrap .el-form-item__error {
          overflow: visible;
          white-space: nowrap;
        }
        .panel-select__desc {
          width: 127px;
          margin: 0;
          color: #262424;
          font-size: 16px;
          height: 22px;
          line-height: 22px;
        }
        .el-form-item {
          .el-form-item__content {
            .fe_input {
              margin-right: 30px;
            }
          }
        }
        .el-input__inner {
          width: 296px !important;
          height: 30px;
        }
        .el-checkbox__label {
          color: #090909;
        }
      }
      .panel-header__auto {
        padding-bottom: 10px;
      }
    }
    .el-dialog__wrapper {
      .el-dialog {
        width: 500px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
        box-sizing: border-box;
        .el-dialog__header {
          position: relative;
          padding: 0;
          padding-top: 30px;
          .dialogTitle {
            text-align: center;
          }
          .el-dialog__headerbtn {
            position: absolute;
            top: 21px;
            right: 0px;
          }
        }
        .el-dialog__body {
          padding: 0;
          margin-top: 26px;
          .dialogContent {
            p {
              color: #282B2D;
              font-size: 16px;
              line-height: 24px;
              padding-bottom: 30px;
              border-bottom: 1px solid #E8E7E6;
            }
          }
        }
        .el-dialog__footer {
          padding: 0;
          margin-top: 20px;
          .dialog-footer {
            button {
              width: 100px;
              height: 40px;
              span {
                font-size: 15px;
              }
            }
            button:nth-child(1) {
              border: 1px solid #FE9B20;
              color: #FE9B20;
            }
            button:nth-child(2) {
              border: none;
              background-color: #7ED321;
              border-radius: 3px;
              color: #FBFBFB;
              margin-left: 20px;
            }
          }
        }
      }
    }
    .el-radio-group {
      .el-radio-button__inner {
        height: 32px;
        padding: 0;
        line-height: 32px;
      }
      .el-radio-button:nth-child(1) {
        width: 73px;
        height: 32px;
        box-sizing: border-box;
        .el-radio-button__inner {
          width: 73px;
        }
      }
      .el-radio-button:nth-child(2) {
        width: 99px;
        height: 32px;
        .el-radio-button__inner {
          width: 99px;
        }
      }
      .el-radio-button:nth-child(3) {
        width: 111px;
        height: 32px;
        .el-radio-button__inner {
          width: 111px;
        }
      }
      .el-radio-button:nth-child(4) {
        width: 122px;
        height: 32px;
        .el-radio-button__inner {
          width: 122px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// linkManage.vue?f7f28ebe